<div *ngIf="posicionCasilla.mostrar"
     id="dragDiv"
     #draggableDiv
     class="draggable resize"
     [ngStyle]="{'top.px': posicionCasilla.top, 'left.px': posicionCasilla.left, 'width.px': 40, 'height.px': 40}">
      <svg #draggableIcon class="icon-draggable">
        <use #draggableHref xlink:href="#icon-draggable"></use>
       </svg>
</div>
